import React from 'react';
import { RatesConfigurationZoneStyled } from './styles';

interface Props {
  children: React.ReactNode;
}

export const RatesConfigurationZone: React.FC<Props> = ({ children }) => {
  return <RatesConfigurationZoneStyled>{children}</RatesConfigurationZoneStyled>;
};
